import * as PropTypes from 'prop-types'

const ExtractionShape = PropTypes.shape({

})

export { ExtractionShape }
